"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageGoodShare = pageGoodShare;
exports.queryGoodShareDetail = queryGoodShareDetail;
exports.updateShareStatus = updateShareStatus;
var _request = _interopRequireDefault(require("@/utils/request"));
/** 分页查询分享清单 */
function pageGoodShare(params) {
  return (0, _request.default)({
    url: '/portal/system/share/page',
    method: 'get',
    params: params
  });
}

/** 查询分享清单详情 */
function queryGoodShareDetail(params) {
  return (0, _request.default)({
    url: '/portal/system/share/detail',
    method: 'get',
    params: params
  });
}

/** 更新共享与上下架开关 */
function updateShareStatus(data) {
  return (0, _request.default)({
    url: '/portal/system/share/status',
    method: 'post',
    data: data
  });
}